.gas-membership-plan {
    container-type: inline-size;
    width: min(100%, var(--gas-site-max-width));
    margin: 0 auto;
    padding: var(--gas-space-xl) var(--gas-space-m) var(--gas-space-3xl);
    color: var(--gas-color-text);
}

.gas-membership-plan__breadcrumb {
    margin-bottom: var(--gas-space-l);
}

.gas-membership-plan__breadcrumb-link {
    display: inline-flex;
    align-items: center;
    gap: var(--gas-space-s);
    color: var(--gas-primary-text);
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-semi);
    text-decoration: none;
}

.gas-membership-plan__breadcrumb-link:hover {
    text-decoration: underline;
}

.gas-membership-plan__hero {
    display: grid;
    overflow: hidden;
    border: var(--gas-border-width) solid var(--gas-color-border-light);
    border-radius: var(--gas-radius-xl);
    background: linear-gradient(
        135deg,
        var(--gas-color-primary-soft),
        var(--gas-color-accent-soft)
    );
    box-shadow: var(--gas-shadow-l);
}

.gas-membership-plan__hero-copy {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: var(--gas-space-xl);
}

.gas-membership-plan__eyebrow,
.gas-membership-plan__section-kicker,
.gas-membership-plan__purchase-kicker {
    margin: 0 0 var(--gas-space-s);
    color: var(--gas-accent-text);
    font-size: var(--gas-text-xs);
    font-weight: var(--gas-weight-bold);
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.gas-membership-plan__title {
    max-width: 16ch;
    margin: 0;
    color: var(--gas-color-text-strong);
    font-family: var(--gas-font-heading);
    font-size: var(--gas-text-4xl);
    line-height: var(--gas-leading-tight);
}

.gas-membership-plan__intro {
    max-width: 58ch;
    margin: var(--gas-space-m) 0 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-l);
    line-height: var(--gas-leading-normal);
}

.gas-membership-plan__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--gas-space-s);
    margin-top: var(--gas-space-l);
}

.gas-membership-plan__price {
    color: var(--gas-primary-text);
    font-size: var(--gas-text-xl);
    font-weight: var(--gas-weight-bold);
}

.gas-membership-plan__period,
.gas-membership-plan__badge {
    display: inline-flex;
    align-items: center;
    min-height: var(--gas-input-height);
    padding: var(--gas-space-xs) var(--gas-space-s);
    border-radius: var(--gas-radius-full);
    background: var(--gas-color-surface-card);
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-semi);
}

.gas-membership-plan__badge {
    color: var(--gas-primary-text);
}

.gas-membership-plan__media {
    min-height: 100%;
    margin: 0;
    overflow: hidden;
    background: var(--gas-tone-dark-bg);
}

.gas-membership-plan__image {
    display: block;
    width: 100%;
    height: 100%;
    aspect-ratio: var(--gas-aspect-card);
    object-fit: cover;
}

.gas-membership-plan__layout {
    display: grid;
    gap: var(--gas-space-xl);
    margin-top: var(--gas-space-2xl);
}

.gas-membership-plan__content {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: var(--gas-space-2xl);
}

.gas-membership-plan__section {
    min-width: 0;
}

.gas-membership-plan__section-title,
.gas-membership-plan__purchase-title {
    margin: 0 0 var(--gas-space-m);
    color: var(--gas-color-text-strong);
    font-family: var(--gas-font-heading);
    font-size: var(--gas-text-2xl);
    line-height: var(--gas-leading-tight);
}

.gas-membership-plan__description {
    max-width: 72ch;
    color: var(--gas-color-text);
    font-size: var(--gas-text-m);
    line-height: var(--gas-leading-relaxed);
}

.gas-membership-plan__description > :first-child {
    margin-top: 0;
}

.gas-membership-plan__description > :last-child {
    margin-bottom: 0;
}

.gas-membership-plan__description h2,
.gas-membership-plan__description h3 {
    color: var(--gas-color-text-strong);
    font-family: var(--gas-font-heading);
    line-height: var(--gas-leading-tight);
}

.gas-membership-plan__features {
    display: grid;
    gap: var(--gas-space-m);
    margin: 0;
    padding: 0;
    list-style: none;
}

.gas-membership-plan__feature {
    display: flex;
    align-items: flex-start;
    gap: var(--gas-space-m);
    padding: var(--gas-space-m);
    border: var(--gas-border-width) solid var(--gas-color-border-light);
    border-radius: var(--gas-radius-l);
    background: var(--gas-color-surface-card);
    box-shadow: var(--gas-shadow-xs);
    color: var(--gas-color-text);
    font-size: var(--gas-text-m);
    line-height: var(--gas-leading-normal);
}

.gas-membership-plan__feature-mark {
    display: inline-flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: var(--gas-space-l);
    height: var(--gas-space-l);
    border-radius: var(--gas-radius-full);
    background: var(--gas-success-light);
    color: var(--gas-success-text);
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-bold);
}

.gas-membership-plan__purchase {
    align-self: start;
    padding: var(--gas-space-l);
    border: var(--gas-border-width) solid var(--gas-color-border-light);
    border-radius: var(--gas-radius-xl);
    background: var(--gas-color-surface-card);
    box-shadow: var(--gas-shadow-m);
}

.gas-membership-plan__summary {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-s);
    margin: 0 0 var(--gas-space-l);
}

.gas-membership-plan__summary-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: var(--gas-space-m);
    padding-bottom: var(--gas-space-s);
    border-bottom: var(--gas-border-width) solid var(--gas-color-border-light);
}

.gas-membership-plan__summary dt {
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
}

.gas-membership-plan__summary dd {
    margin: 0;
    color: var(--gas-color-text-strong);
    font-size: var(--gas-text-m);
    font-weight: var(--gas-weight-bold);
    text-align: right;
}

.gas-membership-plan__notice,
.gas-membership-plan__unavailable {
    margin: 0 0 var(--gas-space-m);
    padding: var(--gas-space-m);
    border-left: var(--gas-border-width-medium) solid var(--gas-warning);
    border-radius: var(--gas-radius-m);
    background: var(--gas-warning-light);
    color: var(--gas-warning-text);
    font-size: var(--gas-text-s);
    line-height: var(--gas-leading-normal);
}

.gas-membership-plan__actions {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-s);
}

.gas-membership-plan__actions .gas-button,
.gas-membership-plan__closing-cta {
    justify-content: center;
    text-align: center;
}

.gas-membership-plan__purchase-hint {
    margin: var(--gas-space-m) 0 0;
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-xs);
    line-height: var(--gas-leading-normal);
    text-align: center;
}

.gas-membership-plan__closing {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-l);
    margin-top: var(--gas-space-2xl);
    padding: var(--gas-space-xl);
    border-radius: var(--gas-radius-xl);
    background: var(--gas-tone-primary-bg);
    color: var(--gas-tone-primary-fg);
}

.gas-membership-plan__closing-title {
    margin: 0;
    color: inherit;
    font-family: var(--gas-font-heading);
    font-size: var(--gas-text-xl);
    font-weight: var(--gas-weight-bold);
}

.gas-membership-plan__closing-text {
    max-width: 64ch;
    margin: var(--gas-space-s) 0 0;
    color: inherit;
    font-size: var(--gas-text-m);
    line-height: var(--gas-leading-normal);
}

.gas-membership-plan__nyp {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-s);
    padding: var(--gas-space-m);
    margin-bottom: var(--gas-space-m);
    background: var(--gas-color-surface-muted);
    border: var(--gas-border-width) solid var(--gas-color-border-light);
    border-radius: var(--gas-radius-m);
}

.gas-membership-plan__nyp-title,
.gas-membership-plan__nyp-hint {
    margin: 0;
}

.gas-membership-plan__nyp-title {
    color: var(--gas-color-text-strong);
    font-size: var(--gas-text-m);
    font-weight: var(--gas-weight-semi);
}

.gas-membership-plan__nyp-hint,
.gas-membership-plan__nyp-label,
.gas-membership-plan__nyp-currency {
    color: var(--gas-color-text-muted);
    font-size: var(--gas-text-s);
}

.gas-membership-plan__nyp-presets {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-xs);
}

.gas-membership-plan__nyp-preset {
    padding: var(--gas-space-xs) var(--gas-space-m);
    border: var(--gas-border-width) solid var(--gas-color-primary);
    border-radius: var(--gas-radius-full);
    background: var(--gas-color-surface-card);
    color: var(--gas-primary-text);
    cursor: pointer;
    font-size: var(--gas-text-s);
    font-weight: var(--gas-weight-medium);
}

.gas-membership-plan__nyp-preset:hover {
    background: var(--gas-color-primary-soft);
}

.gas-membership-plan__nyp-preset--active {
    background: var(--gas-color-primary);
    color: var(--gas-color-on-primary);
}

.gas-membership-plan__nyp-custom {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-xs);
}

.gas-membership-plan__nyp-label {
    font-weight: var(--gas-weight-medium);
}

.gas-membership-plan__nyp-input-wrap {
    display: flex;
    align-items: center;
    gap: var(--gas-space-xs);
}

.gas-membership-plan__nyp-input {
    min-width: 0;
    flex: 1 1 auto;
    padding: var(--gas-space-s);
    border: var(--gas-border-width) solid var(--gas-input-border);
    border-radius: var(--gas-input-radius);
    background: var(--gas-color-surface-card);
    color: var(--gas-color-text);
    font-size: var(--gas-input-font-size);
}

.gas-membership-plan__nyp-input:focus {
    border-color: var(--gas-input-focus-border);
    box-shadow: var(--gas-input-focus-shadow);
    outline: none;
}

.gas-membership-plan__nyp-currency {
    font-weight: var(--gas-weight-semi);
}

@container (min-width: 700px) {
    .gas-membership-plan__hero {
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }

    .gas-membership-plan__hero-copy {
        padding: var(--gas-space-2xl);
    }

    .gas-membership-plan__features {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .gas-membership-plan__closing {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    .gas-membership-plan__closing-cta {
        flex: 0 0 auto;
    }
}

@container (min-width: 920px) {
    .gas-membership-plan__layout {
        grid-template-columns: minmax(0, 1.8fr) minmax(0, 1fr);
        align-items: start;
    }

    .gas-membership-plan__purchase {
        position: sticky;
        top: var(--gas-space-l);
    }
}
